import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Queue, QueueStatus } from '../interfaces/queue.interface';
import { IsLinkRunningObject } from './link-status.service';

@Injectable({
	providedIn: 'root',
})
export class QueueService {
	constructor(private http: HttpClient) {}

	readonly url: string = 'queue';

	public getQueueStatusList(): Observable<QueueStatus[]> {
		return of([
			QueueStatus.AboutToCreateBatch,
			QueueStatus.Completed,
			QueueStatus.CreatedBatch,
			QueueStatus.Failed,
			QueueStatus.InProgress,
			QueueStatus.Unknown,
			QueueStatus.Waiting,
		]);
	}

	public getAllQueueEntries(queueQueryObject: QueueQueryObject): Observable<Queue[]> {
		return this.http.post<Queue[]>(`${this.url}/getAllByQuery`, queueQueryObject);
	}

	public isLinkRunning(linkId: number): Observable<boolean> {
		return this.http.post<boolean>(`${this.url}/${linkId}/IsLinkRunning`, null);
	}

	public areLinksRunning(linkIds: number[]): Observable<IsLinkRunningObject[]> {
		return this.http.post<IsLinkRunningObject[]>(`${this.url}/AreLinksRunning`, linkIds);
	}

	public createQueueEntry(queueCreateDto: Queue) {
		return this.http.post(`${this.url}/Enqueue`, queueCreateDto);
	}

	public GetInstanceHistorySessionId(sessionId: string): Observable<any> {
		let historyParams = new HttpParams();

		historyParams = historyParams.set('sessionId', sessionId);

		return this.http.get<any>(`${this.url}/GetInstanceHistorySessionId`, { params: historyParams });
	}
}

export interface QueueQueryObject {
	fromDate: Date;
	toDate: Date;
	queueStatusFilter?: QueueStatus[] | [];
}
